import {
  SET_ASK_HMD_SURVEY_DATA
} from 'constants/reduxActions';

export default function hmdSurvey(state = {}, { type, data }) {

  switch (type) {
    case SET_ASK_HMD_SURVEY_DATA:
      return data;

    default:
      return state;
  }
}
